export default __webpack_public_path__ + "static/media/img1.1ba38654.PNG";